<script>
export default {
    props: {
        class_exam_session: {
            type: Object
        },
        index: {
            type: Number
        },
        attempt: {
            type: Number
        },
        question_length: {
            type: Number
        },
        question: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        answered: ''
    }),
    created() {
        this.answered = this.question.answered
    },
    computed: {
        answers() {
            if (Array.isArray(this.question.answers) === false)
                return []

            return this.question.answers
        }
    },
    methods: {
        nextQuestion() {
            this.$emit('next')
        },
        backQuestion() {
            this.$emit('back')
        },
        showConfirm() {
            this.$emit('showConfirm')
        },
        update(answer_hash) {
            this.$http.put(this.routeUri('api.classical-exam-questions.answer',
                {
                    question: this.question.hash,
                    attempt: this.attempt
                }
            ), {
                answer: answer_hash
            })
                .then(() => {
                    this.$emit('answer', answer_hash, this.index)
                })
                .catch((e) => this.handleResponseError(e.response.data))
                .finally(() => this.loading = false)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    if(key === 'ended'){
                        this.$emit('ended', true)
                    }else{
                        this.$notification.error({
                            message: "Gagal",
                            description: Object.values(data.errors[key])
                        });
                    }
                }
            }else{
                this.$notification.error({
                    message: "Gagal",
                    description: "Terjadi kesalahan di server"
                });
            }
        },
    },
}
</script>
<template>
    <a-card type="inner" size="small" style="padding: 30px">
        <p><strong>Soal No. {{ index+1 }} </strong></p>
        <p style="white-space: pre-line">
            {{ question.content }}
        </p>
        <a-radio-group v-model="answered">
            <a-list item-layout="horizontal" :dataSource="answers" :split="false">
                <a-list-item slot="renderItem" :key="index" slot-scope="item, index">
                    <div style=" height: 100%; width: 50px; float:left; margin-left: 10px; text-align: center">
                        <a-radio :value="item.hash" style="text-indent: 10px;" @change="(e) => update(item.hash)" />
                    </div>
                    {{ item.content }}
                </a-list-item>
            </a-list>
        </a-radio-group>

        <a-row type="flex" style="margin-top: 48px">
            <a-col :span="24">
                <a-space size="large">
                    <a-button @click="backQuestion" type="primary" :disabled="index < 1"><a-icon type="left" /> Sebelumnya </a-button>
                    <a-button @click="nextQuestion" type="primary" :disabled="(index+1) >= question_length">Selanjutnya <a-icon type="right" /> </a-button>
                </a-space>
                <a-button type="danger" @click="showConfirm" style="margin-top:4px;position: absolute;right: 0;">Akhiri Ujian</a-button>
            </a-col>
        </a-row>

    </a-card>
</template>
